export const TEMPLATE_1 = {
  deviceBg: 'https://appresource.opple.com/media/business/624/20240228142956_61.png',
  deviceText: '550',
  scale: 1,
  isGroup: false,
  shape: 1, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 139,
      "y": 294
    },
    {
      "id": 2,
      "x": 160,
      "y": 234
    },
    {
      "id": 3,
      "x": 181,
      "y": 171
    },
    {
      "id": 4,
      "x": 292,
      "y": 106
    },
    {
      "id": 5,
      "x": 411,
      "y": 163
    },
    {
      "id": 6,
      "x": 432,
      "y": 234
    },
    {
      "id": 7,
      "x": 452,
      "y": 294
    },
    {
      "id": 8,
      "x": 452,
      "y": 350
    },
    {
      "id": 9,
      "x": 432,
      "y": 413
    },
    {
      "id": 10,
      "x": 411,
      "y": 490
    },
    {
      "id": 11,
      "x": 292,
      "y": 549
    },
    {
      "id": 12,
      "x": 181,
      "y": 484
    },
    {
      "id": 13,
      "x": 160,
      "y": 409
    },
    {
      "id": 14,
      "x": 139,
      "y": 350
    },
    {
      "id": 15,
      "x": 11,
      "y": 314,
      shadow: true
    },
    {
      "id": 16,
      "x": 29,
      "y": 243,
      shadow: true
    },
    {
      "id": 17,
      "x": 65,
      "y": 173,
      shadow: true
    },
    {
      "id": 18,
      "x": 114,
      "y": 116,
      shadow: true
    },
    {
      "id": 19,
      "x": 188,
      "y": 70,
      shadow: true
    },
    {
      "id": 20,
      "x": 262,
      "y": 51,
      shadow: true
    },
    {
      "id": 21,
      "x": 341,
      "y": 51,
      shadow: true
    },
    {
      "id": 22,
      "x": 415,
      "y": 70,
      shadow: true
    },
    {
      "id": 23,
      "x": 480,
      "y": 116,
      shadow: true
    },
    {
      "id": 24,
      "x": 527,
      "y": 173,
      shadow: true
    },
    {
      "id": 25,
      "x": 556,
      "y": 243,
      shadow: true
    },
    {
      "id": 26,
      "x": 567,
      "y": 318,
      shadow: true
    }
  ].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 1.166),
    y: Math.floor(item.y * 1.166),
    shadow: item.shadow
  }))
}

export const TEMPLATE_2 = {
  deviceBg: 'https://appresource.opple.com/media/business/3651/20241015194533_85.png',
  deviceText: '6060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [{"id":1,"x":147,"y":76},{"id":2,"x":170,"y":110},{"id":3,"x":192,"y":172},{"id":4,"x":196,"y":235},{"id":5,"x":192,"y":285},{"id":6,"x":211,"y":338},{"id":7,"x":225,"y":387},{"id":8,"x":221,"y":436},{"id":9,"x":217,"y":485},{"id":10,"x":196,"y":556},{"id":11,"x":117,"y":594},{"id":12,"x":597,"y":594},{"id":13,"x":519,"y":556},{"id":14,"x":519,"y":488},{"id":15,"x":519,"y":436},{"id":16,"x":519,"y":387},{"id":17,"x":519,"y":338},{"id":18,"x":516,"y":285},{"id":19,"x":516,"y":235},{"id":20,"x":516,"y":186},{"id":21,"x":509,"y":124},{"id":22,"x":597,"y":76},{"id":23,"x":691,"y":352,"shadow":true},{"id":24,"x":691,"y":242,"shadow":true},{"id":25,"x":691,"y":138,"shadow":true},{"id":26,"x":691,"y":27,"shadow":true},{"id":27,"x":612,"y":8,"shadow":true},{"id":28,"x":516,"y":8,"shadow":true},{"id":29,"x":412,"y":8,"shadow":true},{"id":30,"x":317,"y":8,"shadow":true},{"id":31,"x":221,"y":8,"shadow":true},{"id":32,"x":117,"y":8,"shadow":true},{"id":33,"x":38,"y":27,"shadow":true},{"id":34,"x":38,"y":138,"shadow":true},{"id":35,"x":38,"y":242,"shadow":true},{"id":36,"x":38,"y":352,"shadow":true}].map(item => ({
    ...item,
    x: item.x - 22,
    shadow: item.shadow
  }))
}

export const TEMPLATE_3 = {
  deviceBg: 'https://appresource.opple.com/media/business/2623/20240203141854_25.png',
  deviceText: '900',
  scale: 1,
  isGroup: false,
  shape: 1, // 1 圆形 2 正方形 3 长方形
  posList: [
    {
      "id": 1,
      "x": 259,
      "y": 300
    },
    {
      "id": 2,
      "x": 301,
      "y": 302
    },
    {
      "id": 3,
      "x": 213,
      "y": 270
    },
    {
      "id": 4,
      "x": 301,
      "y": 233
    },
    {
      "id": 5,
      "x": 187,
      "y": 288
    },
    {
      "id": 6,
      "x": 305,
      "y": 342
    },
    {
      "id": 7,
      "x": 288,
      "y": 377
    },
    {
      "id": 8,
      "x": 336,
      "y": 233
    },
    {
      "id": 9,
      "x": 222,
      "y": 199
    },
    {
      "id": 10,
      "x": 171,
      "y": 327
    },
    {
      "id": 11,
      "x": 216,
      "y": 417
    },
    {
      "id": 12,
      "x": 189,
      "y": 455
    },
    {
      "id": 13,
      "x": 219,
      "y": 488
    },
    {
      "id": 14,
      "x": 202,
      "y": 513
    },
    {
      "id": 15,
      "x": 146,
      "y": 475
    },
    {
      "id": 16,
      "x": 87,
      "y": 443
    },
    {
      "id": 17,
      "x": 97,
      "y": 410
    },
    {
      "id": 18,
      "x": 133,
      "y": 423
    },
    {
      "id": 19,
      "x": 158,
      "y": 382
    },
    {
      "id": 20,
      "x": 126,
      "y": 312
    },
    {
      "id": 21,
      "x": 84,
      "y": 317
    },
    {
      "id": 22,
      "x": 64,
      "y": 354
    },
    {
      "id": 23,
      "x": 39,
      "y": 357
    },
    {
      "id": 24,
      "x": 39,
      "y": 288
    },
    {
      "id": 25,
      "x": 39,
      "y": 219
    },
    {
      "id": 26,
      "x": 71,
      "y": 219
    },
    {
      "id": 27,
      "x": 84,
      "y": 251
    },
    {
      "id": 28,
      "x": 126,
      "y": 255
    },
    {
      "id": 29,
      "x": 167,
      "y": 186
    },
    {
      "id": 30,
      "x": 146,
      "y": 157
    },
    {
      "id": 31,
      "x": 99,
      "y": 170
    },
    {
      "id": 32,
      "x": 87,
      "y": 138
    },
    {
      "id": 33,
      "x": 151,
      "y": 100
    },
    {
      "id": 34,
      "x": 218,
      "y": 67
    },
    {
      "id": 35,
      "x": 228,
      "y": 100
    },
    {
      "id": 36,
      "x": 203,
      "y": 125
    },
    {
      "id": 37,
      "x": 224,
      "y": 161
    },
    {
      "id": 38,
      "x": 300,
      "y": 171
    },
    {
      "id": 39,
      "x": 315,
      "y": 131
    },
    {
      "id": 40,
      "x": 285,
      "y": 97
    },
    {
      "id": 41,
      "x": 310,
      "y": 71
    },
    {
      "id": 42,
      "x": 281,
      "y": 13,
      shadow: true
    },
    {
      "id": 43,
      "x": 340,
      "y": 26,
      shadow: true
    },
    {
      "id": 44,
      "x": 396,
      "y": 51,
      shadow: true
    },
    {
      "id": 45,
      "x": 444,
      "y": 87,
      shadow: true
    },
    {
      "id": 46,
      "x": 482,
      "y": 131,
      shadow: true
    },
    {
      "id": 47,
      "x": 369,
      "y": 110
    },
    {
      "id": 48,
      "x": 425,
      "y": 138
    },
    {
      "id": 49,
      "x": 412,
      "y": 173
    },
    {
      "id": 50,
      "x": 376,
      "y": 163
    },
    {
      "id": 51,
      "x": 355,
      "y": 203
    },
    {
      "id": 52,
      "x": 389,
      "y": 271
    },
    {
      "id": 53,
      "x": 428,
      "y": 271
    },
    {
      "id": 54,
      "x": 444,
      "y": 219
    },
    {
      "id": 55,
      "x": 472,
      "y": 223
    },
    {
      "id": 56,
      "x": 507,
      "y": 183,
      shadow: true
    },
    {
      "id": 57,
      "x": 527,
      "y": 238,
      shadow: true
    },
    {
      "id": 58,
      "x": 527,
      "y": 293,
      shadow: true
    },
    {
      "id": 59,
      "x": 521,
      "y": 348,
      shadow: true
    },
    {
      "id": 60,
      "x": 507,
      "y": 408,
      shadow: true
    },
    {
      "id": 61,
      "x": 472,
      "y": 303
    },
    {
      "id": 62,
      "x": 472,
      "y": 372
    },
    {
      "id": 63,
      "x": 438,
      "y": 367
    },
    {
      "id": 64,
      "x": 425,
      "y": 337
    },
    {
      "id": 65,
      "x": 386,
      "y": 332
    },
    {
      "id": 66,
      "x": 335,
      "y": 392
    },
    {
      "id": 67,
      "x": 360,
      "y": 426
    },
    {
      "id": 68,
      "x": 411,
      "y": 420
    },
    {
      "id": 69,
      "x": 415,
      "y": 450
    },
    {
      "id": 70,
      "x": 482,
      "y": 451,
      shadow: true
    },
    {
      "id": 71,
      "x": 444,
      "y": 487,
      shadow: true
    },
    {
      "id": 72,
      "x": 396,
      "y": 523,
      shadow: true
    },
    {
      "id": 73,
      "x": 340,
      "y": 548,
      shadow: true
    },
    {
      "id": 74,
      "x": 281,
      "y": 561,
      shadow: true
    },
    {
      "id": 75,
      "x": 356,
      "y": 475
    },
    {
      "id": 76,
      "x": 299,
      "y": 513
    },
    {
      "id": 77,
      "x": 281,
      "y": 487
    },
    {
      "id": 78,
      "x": 306,
      "y": 461
    },
    {
      "id": 79,
      "x": 286,
      "y": 421
    }
  ].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 1.166),
    y: Math.floor(item.y * 1.166),
    shadow: item.shadow
  }))
}

export const TEMPLATE_4 = {
  deviceBg: 'https://appresource.opple.com/media/business/2623/20240129102013_96.png',
  posList: [
    {
      "id": 1,
      "x": 63,
      "y": 286
    },
    {
      "id": 2,
      "x": 85,
      "y": 212
    },
    {
      "id": 3,
      "x": 107,
      "y": 136
    },
    {
      "id": 4,
      "x": 254,
      "y": 78
    },
    {
      "id": 5,
      "x": 349,
      "y": 136
    },
    {
      "id": 6,
      "x": 371,
      "y": 212
    },
    {
      "id": 7,
      "x": 393,
      "y": 276
    },
    {
      "id": 8,
      "x": 393,
      "y": 342
    },
    {
      "id": 9,
      "x": 371,
      "y": 405
    },
    {
      "id": 10,
      "x": 349,
      "y": 482
    },
    {
      "id": 11,
      "x": 256,
      "y": 544
    },
    {
      "id": 12,
      "x": 107,
      "y": 482
    },
    {
      "id": 13,
      "x": 85,
      "y": 405
    },
    {
      "id": 14,
      "x": 63,
      "y": 342
    },
    {
      "id": 15,
      "x": 22,
      "y": 106
    },
    {
      "id": 16,
      "x": 76,
      "y": 62
    },
    {
      "id": 17,
      "x": 150,
      "y": 25
    },
    {
      "id": 18,
      "x": 235,
      "y": 4
    },
    {
      "id": 19,
      "x": 328,
      "y": 10
    },
    {
      "id": 20,
      "x": 412,
      "y": 46
    },
    {
      "id": 21,
      "x": 478,
      "y": 106
    },
    {
      "id": 22,
      "x": 524,
      "y": 174
    },
    {
      "id": 23,
      "x": 553,
      "y": 251
    },
    {
      "id": 24,
      "x": 560,
      "y": 328
    },
    {
      "id": 25,
      "x": 540,
      "y": 416
    },
    {
      "id": 26,
      "x": 500,
      "y": 487
    }
  ]
}

export const TEMPLATE_5 = {
  deviceBg: 'https://appresource.opple.com/media/business/24/20240719112532_31.png',
  deviceText: '1500',
  scale: 1,
  isGroup: false,
  shape: 1, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 335,
      "y": 314
    },
    {
      "id": 2,
      "x": 347,
      "y": 340
    },
    {
      "id": 3,
      "x": 312,
      "y": 287
    },
    {
      "id": 4,
      "x": 343,
      "y": 366
    },
    {
      "id": 5,
      "x": 367,
      "y": 284
    },
    {
      "id": 6,
      "x": 276,
      "y": 307
    },
    {
      "id": 7,
      "x": 324,
      "y": 387
    },
    {
      "id": 8,
      "x": 394,
      "y": 322
    },
    {
      "id": 9,
      "x": 313,
      "y": 253
    },
    {
      "id": 10,
      "x": 257,
      "y": 333
    },
    {
      "id": 11,
      "x": 269,
      "y": 396
    },
    {
      "id": 12,
      "x": 238,
      "y": 456
    },
    {
      "id": 13,
      "x": 203,
      "y": 510
    },
    {
      "id": 14,
      "x": 184,
      "y": 539
    },
    {
      "id": 15,
      "x": 165,
      "y": 570
    },
    {
      "id": 16,
      "x": 147,
      "y": 589
    },
    {
      "id": 17,
      "x": 111,
      "y": 561
    },
    {
      "id": 18,
      "x": 77,
      "y": 527
    },
    {
      "id": 19,
      "x": 125,
      "y": 540
    },
    {
      "id": 20,
      "x": 103,
      "y": 511
    },
    {
      "id": 21,
      "x": 135,
      "y": 498
    },
    {
      "id": 22,
      "x": 159,
      "y": 468
    },
    {
      "id": 23,
      "x": 188,
      "y": 450
    },
    {
      "id": 24,
      "x": 227,
      "y": 416
    },
    {
      "id": 25,
      "x": 235,
      "y": 363
    },
    {
      "id": 26,
      "x": 188,
      "y": 406
    },
    {
      "id": 27,
      "x": 129,
      "y": 433
    },
    {
      "id": 28,
      "x": 102,
      "y": 451
    },
    {
      "id": 29,
      "x": 74,
      "y": 471
    },
    {
      "id": 30,
      "x": 49,
      "y": 485
    },
    {
      "id": 31,
      "x": 28,
      "y": 443
    },
    {
      "id": 32,
      "x": 13,
      "y": 396
    },
    {
      "id": 33,
      "x": 51,
      "y": 431
    },
    {
      "id": 34,
      "x": 41,
      "y": 394
    },
    {
      "id": 35,
      "x": 75,
      "y": 398
    },
    {
      "id": 36,
      "x": 110,
      "y": 384
    },
    {
      "id": 37,
      "x": 152,
      "y": 380
    },
    {
      "id": 38,
      "x": 195,
      "y": 367
    },
    {
      "id": 39,
      "x": 224,
      "y": 322
    },
    {
      "id": 40,
      "x": 166,
      "y": 333
    },
    {
      "id": 41,
      "x": 102,
      "y": 340
    },
    {
      "id": 42,
      "x": 68,
      "y": 344
    },
    {
      "id": 43,
      "x": 34,
      "y": 351
    },
    {
      "id": 44,
      "x": 3,
      "y": 352
    },
    {
      "id": 45,
      "x": -1,
      "y": 307
    },
    {
      "id": 46,
      "x": 5,
      "y": 255
    },
    {
      "id": 47,
      "x": 31,
      "y": 303
    },
    {
      "id": 48,
      "x": 35,
      "y": 261
    },
    {
      "id": 49,
      "x": 66,
      "y": 288
    },
    {
      "id": 50,
      "x": 103,
      "y": 284
    },
    {
      "id": 51,
      "x": 138,
      "y": 297
    },
    {
      "id": 52,
      "x": 185,
      "y": 303
    },
    {
      "id": 53,
      "x": 237,
      "y": 280
    },
    {
      "id": 54,
      "x": 173,
      "y": 267
    },
    {
      "id": 55,
      "x": 116,
      "y": 242
    },
    {
      "id": 56,
      "x": 81,
      "y": 231
    },
    {
      "id": 57,
      "x": 47,
      "y": 223
    },
    {
      "id": 58,
      "x": 20,
      "y": 210
    },
    {
      "id": 59,
      "x": 38,
      "y": 167
    },
    {
      "id": 60,
      "x": 66,
      "y": 128
    },
    {
      "id": 61,
      "x": 88,
      "y": 146
    },
    {
      "id": 62,
      "x": 65,
      "y": 181
    },
    {
      "id": 63,
      "x": 107,
      "y": 178
    },
    {
      "id": 64,
      "x": 142,
      "y": 192
    },
    {
      "id": 65,
      "x": 165,
      "y": 217
    },
    {
      "id": 66,
      "x": 205,
      "y": 244
    },
    {
      "id": 67,
      "x": 266,
      "y": 241
    },
    {
      "id": 68,
      "x": 213,
      "y": 205
    },
    {
      "id": 69,
      "x": 177,
      "y": 153
    },
    {
      "id": 70,
      "x": 150,
      "y": 129
    },
    {
      "id": 71,
      "x": 117,
      "y": 108
    },
    {
      "id": 72,
      "x": 96,
      "y": 88
    },
    {
      "id": 73,
      "x": 133,
      "y": 57
    },
    {
      "id": 74,
      "x": 175,
      "y": 31
    },
    {
      "id": 75,
      "x": 153,
      "y": 80
    },
    {
      "id": 76,
      "x": 187,
      "y": 59
    },
    {
      "id": 77,
      "x": 191,
      "y": 97
    },
    {
      "id": 78,
      "x": 217,
      "y": 126
    },
    {
      "id": 79,
      "x": 230,
      "y": 162
    },
    {
      "id": 80,
      "x": 247,
      "y": 196
    },
    {
      "id": 81,
      "x": 300,
      "y": 221
    },
    {
      "id": 82,
      "x": 273,
      "y": 169
    },
    {
      "id": 83,
      "x": 261,
      "y": 106
    },
    {
      "id": 84,
      "x": 244,
      "y": 73
    },
    {
      "id": 85,
      "x": 229,
      "y": 43
    },
    {
      "id": 86,
      "x": 219,
      "y": 14
    },
    {
      "id": 87,
      "x": 259,
      "y": 1
    },
    {
      "id": 88,
      "x": 311,
      "y": -3
    },
    {
      "id": 89,
      "x": 268,
      "y": 29
    },
    {
      "id": 90,
      "x": 312,
      "y": 24
    },
    {
      "id": 91,
      "x": 294,
      "y": 62
    },
    {
      "id": 92,
      "x": 311,
      "y": 98
    },
    {
      "id": 93,
      "x": 307,
      "y": 134
    },
    {
      "id": 94,
      "x": 312,
      "y": 178
    },
    {
      "id": 95,
      "x": 347,
      "y": 221
    },
    {
      "id": 96,
      "x": 341,
      "y": 161
    },
    {
      "id": 97,
      "x": 353,
      "y": 95
    },
    {
      "id": 98,
      "x": 356,
      "y": 60
    },
    {
      "id": 99,
      "x": 359,
      "y": 25
    },
    {
      "id": 100,
      "x": 362,
      "y": -4
    },
    {
      "id": 101,
      "x": 409,
      "y": 3
    },
    {
      "id": 102,
      "x": 459,
      "y": 22
    },
    {
      "id": 103,
      "x": 398,
      "y": 32
    },
    {
      "id": 104,
      "x": 440,
      "y": 48
    },
    {
      "id": 105,
      "x": 413,
      "y": 76
    },
    {
      "id": 106,
      "x": 408,
      "y": 111
    },
    {
      "id": 107,
      "x": 385,
      "y": 141
    },
    {
      "id": 108,
      "x": 371,
      "y": 183
    },
    {
      "id": 109,
      "x": 387,
      "y": 242
    },
    {
      "id": 110,
      "x": 410,
      "y": 185
    },
    {
      "id": 111,
      "x": 450,
      "y": 129
    },
    {
      "id": 112,
      "x": 468,
      "y": 104
    },
    {
      "id": 113,
      "x": 482,
      "y": 71
    },
    {
      "id": 114,
      "x": 518,
      "y": 94
    },
    {
      "id": 115,
      "x": 546,
      "y": 127
    },
    {
      "id": 116,
      "x": 507,
      "y": 137
    },
    {
      "id": 117,
      "x": 489,
      "y": 171
    },
    {
      "id": 118,
      "x": 459,
      "y": 189
    },
    {
      "id": 119,
      "x": 425,
      "y": 219
    },
    {
      "id": 120,
      "x": 415,
      "y": 275
    },
    {
      "id": 121,
      "x": 457,
      "y": 235
    },
    {
      "id": 122,
      "x": 518,
      "y": 202
    },
    {
      "id": 123,
      "x": 543,
      "y": 183
    },
    {
      "id": 124,
      "x": 576,
      "y": 161
    },
    {
      "id": 125,
      "x": 597,
      "y": 198
    },
    {
      "id": 126,
      "x": 608,
      "y": 238
    },
    {
      "id": 127,
      "x": 570,
      "y": 231
    },
    {
      "id": 128,
      "x": 536,
      "y": 249
    },
    {
      "id": 129,
      "x": 499,
      "y": 258
    },
    {
      "id": 130,
      "x": 453,
      "y": 268
    },
    {
      "id": 131,
      "x": 423,
      "y": 315
    },
    {
      "id": 132,
      "x": 482,
      "y": 302
    },
    {
      "id": 133,
      "x": 546,
      "y": 301
    },
    {
      "id": 134,
      "x": 583,
      "y": 294
    },
    {
      "id": 135,
      "x": 614,
      "y": 283
    },
    {
      "id": 136,
      "x": 620,
      "y": 325
    },
    {
      "id": 137,
      "x": 614,
      "y": 371
    },
    {
      "id": 138,
      "x": 583,
      "y": 346
    },
    {
      "id": 139,
      "x": 545,
      "y": 354
    },
    {
      "id": 140,
      "x": 511,
      "y": 338
    },
    {
      "id": 141,
      "x": 464,
      "y": 335
    },
    {
      "id": 142,
      "x": 413,
      "y": 359
    },
    {
      "id": 143,
      "x": 472,
      "y": 368
    },
    {
      "id": 144,
      "x": 535,
      "y": 395
    },
    {
      "id": 145,
      "x": 566,
      "y": 402
    },
    {
      "id": 146,
      "x": 602,
      "y": 409
    },
    {
      "id": 147,
      "x": 588,
      "y": 452
    },
    {
      "id": 148,
      "x": 563,
      "y": 486
    },
    {
      "id": 149,
      "x": 545,
      "y": 454
    },
    {
      "id": 150,
      "x": 511,
      "y": 441
    },
    {
      "id": 151,
      "x": 483,
      "y": 415
    },
    {
      "id": 152,
      "x": 446,
      "y": 392
    },
    {
      "id": 153,
      "x": 390,
      "y": 394
    },
    {
      "id": 154,
      "x": 439,
      "y": 433
    },
    {
      "id": 155,
      "x": 485,
      "y": 477
    },
    {
      "id": 156,
      "x": 508,
      "y": 499
    },
    {
      "id": 157,
      "x": 537,
      "y": 525
    },
    {
      "id": 158,
      "x": 503,
      "y": 555
    },
    {
      "id": 159,
      "x": 464,
      "y": 576
    },
    {
      "id": 160,
      "x": 462,
      "y": 538
    },
    {
      "id": 161,
      "x": 440,
      "y": 510
    },
    {
      "id": 162,
      "x": 427,
      "y": 477
    },
    {
      "id": 163,
      "x": 404,
      "y": 440
    },
    {
      "id": 164,
      "x": 352,
      "y": 415
    },
    {
      "id": 165,
      "x": 377,
      "y": 469
    },
    {
      "id": 166,
      "x": 403,
      "y": 531
    },
    {
      "id": 167,
      "x": 413,
      "y": 562
    },
    {
      "id": 168,
      "x": 426,
      "y": 595
    },
    {
      "id": 169,
      "x": 382,
      "y": 609
    },
    {
      "id": 170,
      "x": 338,
      "y": 611
    },
    {
      "id": 171,
      "x": 356,
      "y": 574
    },
    {
      "id": 172,
      "x": 345,
      "y": 541
    },
    {
      "id": 173,
      "x": 346,
      "y": 504
    },
    {
      "id": 174,
      "x": 342,
      "y": 458
    },
    {
      "id": 175,
      "x": 304,
      "y": 415
    },
    {
      "id": 176,
      "x": 305,
      "y": 478
    },
    {
      "id": 177,
      "x": 301,
      "y": 543
    },
    {
      "id": 178,
      "x": 297,
      "y": 577
    },
    {
      "id": 179,
      "x": 293,
      "y": 610
    },
    {
      "id": 180,
      "x": 247,
      "y": 603
    },
    {
      "id": 181,
      "x": 208,
      "y": 588
    },
    {
      "id": 182,
      "x": 242,
      "y": 563
    },
    {
      "id": 183,
      "x": 241,
      "y": 526
    },
    {
      "id": 184,
      "x": 261,
      "y": 494
    },
    {
      "id": 185,
      "x": 278,
      "y": 448
    }
  ].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 1) + 17,
    y: Math.floor(item.y *  1) + 25,
    shadow: item.shadow
  }))
}

export const TEMPLATE_6 = {
  deviceBg: 'https://appresource.opple.com/media/business/102/20240627145452_92.png',
  deviceText: '550V2.0',
  scale: 1,
  isGroup: false,
  shape: 1, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 337,
      "y": 378
    },
    {
      "id": 2,
      "x": 386,
      "y": 283
    },
    {
      "id": 3,
      "x": 351,
      "y": 422
    },
    {
      "id": 4,
      "x": 246,
      "y": 353
    },
    {
      "id": 5,
      "x": 337,
      "y": 213
    },
    {
      "id": 6,
      "x": 216,
      "y": 262
    },
    {
      "id": 7,
      "x": 246,
      "y": 430
    },
    {
      "id": 8,
      "x": 421,
      "y": 437
    },
    {
      "id": 9,
      "x": 457,
      "y": 269
    },
    {
      "id": 10,
      "x": 288,
      "y": 156
    },
    {
      "id": 11,
      "x": 169,
      "y": 248
    },
    {
      "id": 12,
      "x": 176,
      "y": 423
    },
    {
      "id": 13,
      "x": 351,
      "y": 519
    },
    {
      "id": 14,
      "x": 506,
      "y": 402
    },
    {
      "id": 15,
      "x": 492,
      "y": 227
    },
    {
      "id": 16,
      "x": 604,
      "y": 255
    },
    {
      "id": 17,
      "x": 562,
      "y": 297
    },
    {
      "id": 18,
      "x": 597,
      "y": 430
    },
    {
      "id": 19,
      "x": 527,
      "y": 472
    },
    {
      "id": 20,
      "x": 492,
      "y": 563
    },
    {
      "id": 21,
      "x": 400,
      "y": 549
    },
    {
      "id": 22,
      "x": 260,
      "y": 598
    },
    {
      "id": 23,
      "x": 253,
      "y": 548
    },
    {
      "id": 24,
      "x": 120,
      "y": 507
    },
    {
      "id": 25,
      "x": 127,
      "y": 437
    },
    {
      "id": 26,
      "x": 57,
      "y": 332
    },
    {
      "id": 27,
      "x": 106,
      "y": 269
    },
    {
      "id": 28,
      "x": 141,
      "y": 129
    },
    {
      "id": 29,
      "x": 183,
      "y": 150
    },
    {
      "id": 30,
      "x": 295,
      "y": 52
    },
    {
      "id": 31,
      "x": 351,
      "y": 94
    },
    {
      "id": 32,
      "x": 471,
      "y": 87
    },
    {
      "id": 33,
      "x": 492,
      "y": 157
    },
    {
      "id": 34,
      "x": 646,
      "y": 255,
      shadow: true
    },
    {
      "id": 35,
      "x": 562,
      "y": 108,
      shadow: true
    },
    {
      "id": 36,
      "x": 428,
      "y": 24,
      shadow: true
    },
    {
      "id": 37,
      "x": 260,
      "y": 24,
      shadow: true
    },
    {
      "id": 38,
      "x": 120,
      "y": 101,
      shadow: true
    },
    {
      "id": 39,
      "x": 36,
      "y": 241,
      shadow: true
    },
    {
      "id": 40,
      "x": 29,
      "y": 402,
      shadow: true
    },
    {
      "id": 41,
      "x": 127,
      "y": 570,
      shadow: true
    },
    {
      "id": 42,
      "x": 260,
      "y": 644,
      shadow: true
    },
    {
      "id": 43,
      "x": 428,
      "y": 642,
      shadow: true
    },
    {
      "id": 44,
      "x": 562,
      "y": 562,
      shadow: true
    },
    {
      "id": 45,
      "x": 644,
      "y": 416,
      shadow: true
    }
  ]
}

export const TEMPLATE_7 = {
  deviceBg: 'https://appresource.opple.com/media/business/2724/20240823130729_97.png',
  deviceText: '960',
  scale: 1,
  isGroup: false,
  shape: 1, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 237,
      "y": 673
    },
    {
      "id": 2,
      "x": 237,
      "y": 640
    },
    {
      "id": 3,
      "x": 237,
      "y": 603
    },
    {
      "id": 4,
      "x": 237,
      "y": 558
    },
    {
      "id": 5,
      "x": 237,
      "y": 507
    },
    {
      "id": 6,
      "x": 237,
      "y": 464
    },
    {
      "id": 7,
      "x": 237,
      "y": 431
    },
    {
      "id": 8,
      "x": 169,
      "y": 396
    },
    {
      "id": 9,
      "x": 237,
      "y": 365
    },
    {
      "id": 10,
      "x": 157,
      "y": 330
    },
    {
      "id": 11,
      "x": 237,
      "y": 299
    },
    {
      "id": 12,
      "x": 237,
      "y": 262
    },
    {
      "id": 13,
      "x": 237,
      "y": 217
    },
    {
      "id": 14,
      "x": 237,
      "y": 171
    },
    {
      "id": 15,
      "x": 237,
      "y": 129
    },
    {
      "id": 16,
      "x": 237,
      "y": 90
    },
    {
      "id": 17,
      "x": 237,
      "y": 58
    },
    {
      "id": 18,
      "x": 464,
      "y": 58
    },
    {
      "id": 19,
      "x": 464,
      "y": 90
    },
    {
      "id": 20,
      "x": 464,
      "y": 127
    },
    {
      "id": 21,
      "x": 464,
      "y": 171
    },
    {
      "id": 22,
      "x": 464,
      "y": 216
    },
    {
      "id": 23,
      "x": 464,
      "y": 261
    },
    {
      "id": 24,
      "x": 464,
      "y": 298
    },
    {
      "id": 25,
      "x": 545,
      "y": 326
    },
    {
      "id": 26,
      "x": 476,
      "y": 372
    },
    {
      "id": 27,
      "x": 545,
      "y": 395
    },
    {
      "id": 28,
      "x": 476,
      "y": 430
    },
    {
      "id": 29,
      "x": 476,
      "y": 463
    },
    {
      "id": 30,
      "x": 476,
      "y": 506
    },
    {
      "id": 31,
      "x": 476,
      "y": 557
    },
    {
      "id": 32,
      "x": 476,
      "y": 600
    },
    {
      "id": 33,
      "x": 476,
      "y": 637
    },
    {
      "id": 34,
      "x": 476,
      "y": 672
    },
    {
      "id": 35,
      "x": 609,
      "y": 337
    },
    {
      "id": 36,
      "x": 609,
      "y": 275
    },
    {
      "id": 37,
      "x": 609,
      "y": 213
    },
    {
      "id": 38,
      "x": 609,
      "y": 151
    },
    {
      "id": 39,
      "x": 609,
      "y": 89
    },
    {
      "id": 40,
      "x": 609,
      "y": 27
    },
    {
      "id": 41,
      "x": 560,
      "y": 14
    },
    {
      "id": 42,
      "x": 500,
      "y": 14
    },
    {
      "id": 43,
      "x": 439,
      "y": 14
    },
    {
      "id": 44,
      "x": 379,
      "y": 14
    },
    {
      "id": 45,
      "x": 318,
      "y": 14
    },
    {
      "id": 46,
      "x": 258,
      "y": 14
    },
    {
      "id": 47,
      "x": 198,
      "y": 14
    },
    {
      "id": 48,
      "x": 137,
      "y": 14
    },
    {
      "id": 49,
      "x": 90,
      "y": 27
    },
    {
      "id": 50,
      "x": 90,
      "y": 89
    },
    {
      "id": 51,
      "x": 90,
      "y": 151
    },
    {
      "id": 52,
      "x": 90,
      "y": 213
    },
    {
      "id": 53,
      "x": 90,
      "y": 275
    },
    {
      "id": 54,
      "x": 90,
      "y": 337
    }
  ].map(item => ({
    id: item.id,
    x: Math.floor(item.x) - 10,
    y: item.y,
    shadow: item.shadow
  }))
}


export const TEMPLATE_8 = {
  deviceBg: 'https://appresource.opple.com/media/business/24/20240924174652_42.png',
  deviceText: '60x120',
  scale: 0.5,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 15,
      "y": 20
    },
    {
      "id": 2,
      "x": 75,
      "y": 20
    },
    {
      "id": 3,
      "x": 135,
      "y": 20
    },
    {
      "id": 4,
      "x": 190,
      "y": 20
    },
    {
      "id": 5,
      "x": 255,
      "y": 20
    },
    {
      "id": 6,
      "x": 310,
      "y": 20
    },
    {
      "id": 7,
      "x": 365,
      "y": 20
    },
    {
      "id": 8,
      "x": 420,
      "y": 20
    },
    {
      "id": 9,
      "x": 483,
      "y": 20
    },
    {
      "id": 10,
      "x": 540,
      "y": 20
    },
    {
      "id": 11,
      "x": 600,
      "y": 20
    },
    {
      "id": 12,
      "x": 660,
      "y": 20
    },
    {
      "id": 13,
      "x": 660,
      "y": 75
    },
    {
      "id": 14,
      "x": 600,
      "y": 75
    },
    {
      "id": 15,
      "x": 540,
      "y": 75
    },
    {
      "id": 16,
      "x": 483,
      "y": 75
    },
    {
      "id": 17,
      "x": 420,
      "y": 75
    },
    {
      "id": 18,
      "x": 365,
      "y": 75
    },
    {
      "id": 19,
      "x": 310,
      "y": 75
    },
    {
      "id": 20,
      "x": 255,
      "y": 75
    },
    {
      "id": 21,
      "x": 190,
      "y": 75
    },
    {
      "id": 22,
      "x": 135,
      "y": 75
    },
    {
      "id": 23,
      "x": 75,
      "y": 75
    },
    {
      "id": 24,
      "x": 15,
      "y": 75
    },
    {
      "id": 25,
      "x": 15,
      "y": 130
    },
    {
      "id": 26,
      "x": 75,
      "y": 130
    },
    {
      "id": 27,
      "x": 135,
      "y": 130
    },
    {
      "id": 28,
      "x": 190,
      "y": 130
    },
    {
      "id": 29,
      "x": 255,
      "y": 130
    },
    {
      "id": 30,
      "x": 310,
      "y": 130
    },
    {
      "id": 31,
      "x": 365,
      "y": 130
    },
    {
      "id": 32,
      "x": 420,
      "y": 130
    },
    {
      "id": 33,
      "x": 483,
      "y": 130
    },
    {
      "id": 34,
      "x": 540,
      "y": 130
    },
    {
      "id": 35,
      "x": 600,
      "y": 130
    },
    {
      "id": 36,
      "x": 660,
      "y": 130
    },
    {
      "id": 37,
      "x": 660,
      "y": 185
    },
    {
      "id": 38,
      "x": 600,
      "y": 185
    },
    {
      "id": 39,
      "x": 540,
      "y": 185
    },
    {
      "id": 40,
      "x": 483,
      "y": 185
    },
    {
      "id": 41,
      "x": 420,
      "y": 185
    },
    {
      "id": 42,
      "x": 365,
      "y": 185
    },
    {
      "id": 43,
      "x": 310,
      "y": 185
    },
    {
      "id": 44,
      "x": 255,
      "y": 185
    },
    {
      "id": 45,
      "x": 190,
      "y": 185
    },
    {
      "id": 46,
      "x": 135,
      "y": 185
    },
    {
      "id": 47,
      "x": 75,
      "y": 185
    },
    {
      "id": 48,
      "x": 15,
      "y": 185
    },
    {
      "id": 49,
      "x": 15,
      "y": 250
    },
    {
      "id": 50,
      "x": 75,
      "y": 250
    },
    {
      "id": 51,
      "x": 135,
      "y": 250
    },
    {
      "id": 52,
      "x": 190,
      "y": 250
    },
    {
      "id": 53,
      "x": 255,
      "y": 250
    },
    {
      "id": 54,
      "x": 310,
      "y": 250
    },
    {
      "id": 55,
      "x": 365,
      "y": 250
    },
    {
      "id": 56,
      "x": 420,
      "y": 250
    },
    {
      "id": 57,
      "x": 483,
      "y": 250
    },
    {
      "id": 58,
      "x": 540,
      "y": 250
    },
    {
      "id": 59,
      "x": 600,
      "y": 250
    },
    {
      "id": 60,
      "x": 660,
      "y": 250
    },
    {
      "id": 61,
      "x": 660,
      "y": 310
    },
    {
      "id": 62,
      "x": 600,
      "y": 310
    },
    {
      "id": 63,
      "x": 540,
      "y": 310
    },
    {
      "id": 64,
      "x": 483,
      "y": 310
    },
    {
      "id": 65,
      "x": 420,
      "y": 310
    },
    {
      "id": 66,
      "x": 365,
      "y": 310
    },
    {
      "id": 67,
      "x": 310,
      "y": 310
    },
    {
      "id": 68,
      "x": 255,
      "y": 310
    },
    {
      "id": 69,
      "x": 190,
      "y": 310
    },
    {
      "id": 70,
      "x": 135,
      "y": 310
    },
    {
      "id": 71,
      "x": 75,
      "y": 310
    },
    {
      "id": 72,
      "x": 15,
      "y": 310
    }
  ].map(item => ({
    id: item.id,
    x: item.x,
    y: item.y,
    // x: Math.floor(item.x) - 10,
    // y: item.y,
    shadow: item.shadow
  }))
}

export const TEMPLATE_9 = {
  deviceBg: 'https://appresource.opple.com/media/business/24/20240924184812_41.png',
  deviceText: '60x180',
  scale: 0.35,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
    {
      "id": 1,
      "x": 10,
      "y": 12
    },
    {
      "id": 2,
      "x": 50,
      "y": 12
    },
    {
      "id": 3,
      "x": 88,
      "y": 12
    },
    {
      "id": 4,
      "x": 127,
      "y": 12
    },
    {
      "id": 5,
      "x": 166,
      "y": 12
    },
    {
      "id": 6,
      "x": 207,
      "y": 12
    },
    {
      "id": 7,
      "x": 244,
      "y": 12
    },
    {
      "id": 8,
      "x": 282,
      "y": 12
    },
    {
      "id": 9,
      "x": 324,
      "y": 12
    },
    {
      "id": 10,
      "x": 362,
      "y": 12
    },
    {
      "id": 11,
      "x": 400,
      "y": 12
    },
    {
      "id": 12,
      "x": 440,
      "y": 12
    },
    {
      "id": 13,
      "x": 475,
      "y": 12
    },
    {
      "id": 14,
      "x": 516,
      "y": 12
    },
    {
      "id": 15,
      "x": 556,
      "y": 12
    },
    {
      "id": 16,
      "x": 597,
      "y": 12
    },
    {
      "id": 17,
      "x": 636,
      "y": 12
    },
    {
      "id": 18,
      "x": 673,
      "y": 12
    },
    {
      "id": 19,
      "x": 673,
      "y": 53
    },
    {
      "id": 20,
      "x": 636,
      "y": 53
    },
    {
      "id": 21,
      "x": 597,
      "y": 53
    },
    {
      "id": 22,
      "x": 556,
      "y": 53
    },
    {
      "id": 23,
      "x": 516,
      "y": 53
    },
    {
      "id": 24,
      "x": 475,
      "y": 53
    },
    {
      "id": 25,
      "x": 440,
      "y": 53
    },
    {
      "id": 26,
      "x": 400,
      "y": 53
    },
    {
      "id": 27,
      "x": 362,
      "y": 53
    },
    {
      "id": 28,
      "x": 324,
      "y": 53
    },
    {
      "id": 29,
      "x": 282,
      "y": 53
    },
    {
      "id": 30,
      "x": 244,
      "y": 53
    },
    {
      "id": 31,
      "x": 207,
      "y": 53
    },
    {
      "id": 32,
      "x": 169,
      "y": 53
    },
    {
      "id": 33,
      "x": 127,
      "y": 53
    },
    {
      "id": 34,
      "x": 88,
      "y": 53
    },
    {
      "id": 35,
      "x": 50,
      "y": 53
    },
    {
      "id": 36,
      "x": 10,
      "y": 53
    },
    {
      "id": 37,
      "x": 10,
      "y": 91
    },
    {
      "id": 38,
      "x": 50,
      "y": 91
    },
    {
      "id": 39,
      "x": 88,
      "y": 91
    },
    {
      "id": 40,
      "x": 127,
      "y": 91
    },
    {
      "id": 41,
      "x": 169,
      "y": 91
    },
    {
      "id": 42,
      "x": 207,
      "y": 91
    },
    {
      "id": 43,
      "x": 244,
      "y": 91
    },
    {
      "id": 44,
      "x": 282,
      "y": 91
    },
    {
      "id": 45,
      "x": 324,
      "y": 91
    },
    {
      "id": 46,
      "x": 362,
      "y": 91
    },
    {
      "id": 47,
      "x": 400,
      "y": 91
    },
    {
      "id": 48,
      "x": 440,
      "y": 91
    },
    {
      "id": 49,
      "x": 475,
      "y": 91
    },
    {
      "id": 50,
      "x": 516,
      "y": 91
    },
    {
      "id": 51,
      "x": 556,
      "y": 91
    },
    {
      "id": 52,
      "x": 597,
      "y": 91
    },
    {
      "id": 53,
      "x": 636,
      "y": 91
    },
    {
      "id": 54,
      "x": 673,
      "y": 91
    },
    {
      "id": 55,
      "x": 673,
      "y": 134
    },
    {
      "id": 56,
      "x": 636,
      "y": 134
    },
    {
      "id": 57,
      "x": 597,
      "y": 134
    },
    {
      "id": 58,
      "x": 556,
      "y": 134
    },
    {
      "id": 59,
      "x": 516,
      "y": 134
    },
    {
      "id": 60,
      "x": 475,
      "y": 134
    },
    {
      "id": 61,
      "x": 440,
      "y": 134
    },
    {
      "id": 62,
      "x": 400,
      "y": 134
    },
    {
      "id": 63,
      "x": 362,
      "y": 134
    },
    {
      "id": 64,
      "x": 324,
      "y": 134
    },
    {
      "id": 65,
      "x": 282,
      "y": 134
    },
    {
      "id": 66,
      "x": 244,
      "y": 134
    },
    {
      "id": 67,
      "x": 207,
      "y": 134
    },
    {
      "id": 68,
      "x": 169,
      "y": 134
    },
    {
      "id": 69,
      "x": 127,
      "y": 134
    },
    {
      "id": 70,
      "x": 88,
      "y": 134
    },
    {
      "id": 71,
      "x": 50,
      "y": 134
    },
    {
      "id": 72,
      "x": 10,
      "y": 134
    },
    {
      "id": 73,
      "x": 10,
      "y": 174
    },
    {
      "id": 74,
      "x": 50,
      "y": 174
    },
    {
      "id": 75,
      "x": 88,
      "y": 174
    },
    {
      "id": 76,
      "x": 127,
      "y": 174
    },
    {
      "id": 77,
      "x": 169,
      "y": 174
    },
    {
      "id": 78,
      "x": 207,
      "y": 174
    },
    {
      "id": 79,
      "x": 244,
      "y": 174
    },
    {
      "id": 80,
      "x": 282,
      "y": 174
    },
    {
      "id": 81,
      "x": 324,
      "y": 174
    },
    {
      "id": 82,
      "x": 362,
      "y": 174
    },
    {
      "id": 83,
      "x": 400,
      "y": 174
    },
    {
      "id": 84,
      "x": 440,
      "y": 174
    },
    {
      "id": 85,
      "x": 475,
      "y": 174
    },
    {
      "id": 86,
      "x": 516,
      "y": 174
    },
    {
      "id": 87,
      "x": 556,
      "y": 174
    },
    {
      "id": 88,
      "x": 597,
      "y": 174
    },
    {
      "id": 89,
      "x": 636,
      "y": 174
    },
    {
      "id": 90,
      "x": 673,
      "y": 174
    },
    {
      "id": 91,
      "x": 673,
      "y": 214
    },
    {
      "id": 92,
      "x": 636,
      "y": 214
    },
    {
      "id": 93,
      "x": 597,
      "y": 214
    },
    {
      "id": 94,
      "x": 556,
      "y": 214
    },
    {
      "id": 95,
      "x": 516,
      "y": 214
    },
    {
      "id": 96,
      "x": 475,
      "y": 214
    },
    {
      "id": 97,
      "x": 440,
      "y": 214
    },
    {
      "id": 98,
      "x": 400,
      "y": 214
    },
    {
      "id": 99,
      "x": 362,
      "y": 214
    },
    {
      "id": 100,
      "x": 324,
      "y": 214
    },
    {
      "id": 101,
      "x": 282,
      "y": 214
    },
    {
      "id": 102,
      "x": 244,
      "y": 214
    },
    {
      "id": 103,
      "x": 207,
      "y": 214
    },
    {
      "id": 104,
      "x": 169,
      "y": 214
    },
    {
      "id": 105,
      "x": 127,
      "y": 214
    },
    {
      "id": 106,
      "x": 88,
      "y": 214
    },
    {
      "id": 107,
      "x": 50,
      "y": 214
    },
    {
      "id": 108,
      "x": 10,
      "y": 214
    }
  ].map(item => ({
    ...item,
    id: item.id,
    shadow: item.shadow
  }))
}

export const TEMPLATE_10 = {
  deviceBg: 'https://appresource.opple.com/media/business/3651/20241015182808_79.png',
  deviceText: '3060',
  scale: 1.67,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [{"id":1,"x":136,"y":416},{"id":2,"x":252,"y":260},{"id":3,"x":348,"y":451},{"id":4,"x":452.5,"y":277.2},{"id":5,"x":532,"y":169},{"id":6,"x":551,"y":895},{"id":7,"x":385,"y":1036},{"id":8,"x":330,"y":841.68},{"id":9,"x":252,"y":1036},{"id":10,"x":136,"y":1110},{"id":11,"x":24,"y":588, shadow: true},{"id":12,"x":24,"y":433, shadow: true},{"id":13,"x":24,"y":278, shadow: true},{"id":14,"x":24,"y":105,shadow: true},{"id":15,"x":155,"y":36, shadow: true},{"id":16,"x":350,"y":36, shadow: true},{"id":17,"x":543.5,"y":36, shadow: true},{"id":18,"x":662,"y":105, shadow: true},{"id":19,"x":662,"y":277, shadow: true},{"id":20,"x":662,"y":448, shadow: true},{"id":21,"x":662,"y":619, shadow: true}].map(item => ({
    ...item,
    shadow: !!item.shadow
  }))
}

export const TEMPLATE_11 = {
  deviceBg: 'https://appresource.opple.com/media/business/3484/20250814180753_86',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 622,
    "y": 315
  },
  {
    "id": 2,
    "x": 393,
    "y": 318
  },
  {
    "id": 3,
    "x": 393,
    "y": 447
  },
  {
    "id": 4,
    "x": 600,
    "y": 438
  },
  {
    "id": 5,
    "x": 806,
    "y": 438
  },
  {
    "id": 6,
    "x": 798,
    "y": 317
  },
  {
    "id": 7,
    "x": 680,
    "y": 198
  },
  {
    "id": 8,
    "x": 466,
    "y": 125
  },
  {
    "id": 9,
    "x": 315,
    "y": 217
  },
  {
    "id": 10,
    "x": 197,
    "y": 323
  },
  {
    "id": 11,
    "x": 166,
    "y": 442
  },
  {
    "id": 12,
    "x": 354,
    "y": 661
  },
  {
    "id": 13,
    "x": 622,
    "y": 668
  },
  {
    "id": 14,
    "x": 611,
    "y": 549
  },
  {
    "id": 15,
    "x": 389,
    "y": 545
  },
  {
    "id": 16,
    "x": 185,
    "y": 543
  },
  {
    "id": 17,
    "x": 204,
    "y": 668
  },
  {
    "id": 18,
    "x": 307,
    "y": 785
  },
  {
    "id": 19,
    "x": 522,
    "y": 852
  },
  {
    "id": 20,
    "x": 672,
    "y": 785
  },
  {
    "id": 21,
    "x": 795,
    "y": 649
  },
  {
    "id": 22,
    "x": 833,
    "y": 539
  },
  {
    "id": 23,
    "x": 976,
    "y": 438
  },
  {
    "id": 24,
    "x": 948,
    "y": 331
  },
  {
    "id": 25,
    "x": 891,
    "y": 221
  },
  {
    "id": 26,
    "x": 820,
    "y": 142
  },
  {
    "id": 27,
    "x": 726,
    "y": 77
  },
  {
    "id": 28,
    "x": 608,
    "y": 28
  },
  {
    "id": 29,
    "x": 500,
    "y": 20
  },
  {
    "id": 30,
    "x": 389,
    "y": 32
  },
  {
    "id": 31,
    "x": 288,
    "y": 70
  },
  {
    "id": 32,
    "x": 208,
    "y": 119
  },
  {
    "id": 33,
    "x": 132,
    "y": 193
  },
  {
    "id": 34,
    "x": 71,
    "y": 279
  },
  {
    "id": 35,
    "x": 35,
    "y": 381
  },
  {
    "id": 36,
    "x": 26,
    "y": 496
  },
  {
    "id": 37,
    "x": 35,
    "y": 626
  },
  {
    "id": 38,
    "x": 79,
    "y": 735
  },
  {
    "id": 39,
    "x": 147,
    "y": 824
  },
  {
    "id": 40,
    "x": 223,
    "y": 885
  },
  {
    "id": 41,
    "x": 299,
    "y": 938
  },
  {
    "id": 42,
    "x": 400,
    "y": 969
  },
  {
    "id": 43,
    "x": 500,
    "y": 984
  },
  {
    "id": 44,
    "x": 615,
    "y": 969
  },
  {
    "id": 45,
    "x": 733,
    "y": 925
  },
  {
    "id": 46,
    "x": 828,
    "y": 856
  },
  {
    "id": 47,
    "x": 900,
    "y": 770
  },
  {
    "id": 48,
    "x": 948,
    "y": 663
  },
  {
    "id": 49,
    "x": 977,
    "y": 553
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.69) -5,
    y: Math.floor(item.y *  0.69) - 5,
    shadow: item.shadow
  }))
}

export const TEMPLATE_12 = {
  deviceBg: 'https://appresource.opple.com/media/business/3484/20250815144036_100',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 458,
    "y": 309
  },
  {
    "id": 2,
    "x": 458,
    "y": 445
  },
  {
    "id": 3,
    "x": 458,
    "y": 544
  },
  {
    "id": 4,
    "x": 458,
    "y": 650
  },
  {
    "id": 5,
    "x": 454,
    "y": 740
  },
  {
    "id": 6,
    "x": 369,
    "y": 687
  },
  {
    "id": 7,
    "x": 369,
    "y": 578
  },
  {
    "id": 8,
    "x": 369,
    "y": 468
  },
  {
    "id": 9,
    "x": 369,
    "y": 356
  },
  {
    "id": 10,
    "x": 369,
    "y": 244
  },
  {
    "id": 11,
    "x": 458,
    "y": 219
  },
  {
    "id": 12,
    "x": 458,
    "y": 138
  },
  {
    "id": 13,
    "x": 385,
    "y": 138
  },
  {
    "id": 14,
    "x": 284,
    "y": 157
  },
  {
    "id": 15,
    "x": 284,
    "y": 250
  },
  {
    "id": 16,
    "x": 283,
    "y": 342
  },
  {
    "id": 17,
    "x": 276,
    "y": 437
  },
  {
    "id": 18,
    "x": 292,
    "y": 560
  },
  {
    "id": 19,
    "x": 279,
    "y": 679
  },
  {
    "id": 20,
    "x": 369,
    "y": 799
  },
  {
    "id": 21,
    "x": 450,
    "y": 812
  },
  {
    "id": 22,
    "x": 434,
    "y": 877
  },
  {
    "id": 23,
    "x": 280,
    "y": 869
  },
  {
    "id": 24,
    "x": 276,
    "y": 764
  },
  {
    "id": 25,
    "x": 568,
    "y": 687
  },
  {
    "id": 26,
    "x": 560,
    "y": 574
  },
  {
    "id": 27,
    "x": 556,
    "y": 449
  },
  {
    "id": 28,
    "x": 556,
    "y": 356
  },
  {
    "id": 29,
    "x": 556,
    "y": 263
  },
  {
    "id": 30,
    "x": 642,
    "y": 317
  },
  {
    "id": 31,
    "x": 642,
    "y": 429
  },
  {
    "id": 32,
    "x": 642,
    "y": 540
  },
  {
    "id": 33,
    "x": 650,
    "y": 658
  },
  {
    "id": 34,
    "x": 650,
    "y": 764
  },
  {
    "id": 35,
    "x": 556,
    "y": 787
  },
  {
    "id": 36,
    "x": 556,
    "y": 869
  },
  {
    "id": 37,
    "x": 642,
    "y": 869
  },
  {
    "id": 38,
    "x": 712,
    "y": 843
  },
  {
    "id": 39,
    "x": 729,
    "y": 756
  },
  {
    "id": 40,
    "x": 729,
    "y": 658
  },
  {
    "id": 41,
    "x": 729,
    "y": 556
  },
  {
    "id": 42,
    "x": 725,
    "y": 445
  },
  {
    "id": 43,
    "x": 725,
    "y": 342
  },
  {
    "id": 44,
    "x": 654,
    "y": 212
  },
  {
    "id": 45,
    "x": 552,
    "y": 197
  },
  {
    "id": 46,
    "x": 583,
    "y": 130
  },
  {
    "id": 47,
    "x": 742,
    "y": 134
  },
  {
    "id": 48,
    "x": 742,
    "y": 227
  },
  {
    "id": 49,
    "x": 856,
    "y": 240
  },
  {
    "id": 50,
    "x": 856,
    "y": 189
  },
  {
    "id": 51,
    "x": 856,
    "y": 134
  },
  {
    "id": 52,
    "x": 785,
    "y": 25
  },
  {
    "id": 53,
    "x": 729,
    "y": 25
  },
  {
    "id": 54,
    "x": 666,
    "y": 25
  },
  {
    "id": 55,
    "x": 603,
    "y": 27
  },
  {
    "id": 56,
    "x": 540,
    "y": 27
  },
  {
    "id": 57,
    "x": 477,
    "y": 29
  },
  {
    "id": 58,
    "x": 414,
    "y": 27
  },
  {
    "id": 59,
    "x": 358,
    "y": 27
  },
  {
    "id": 60,
    "x": 296,
    "y": 27
  },
  {
    "id": 61,
    "x": 229,
    "y": 27
  },
  {
    "id": 62,
    "x": 155,
    "y": 134
  },
  {
    "id": 63,
    "x": 155,
    "y": 185
  },
  {
    "id": 64,
    "x": 155,
    "y": 240
  },
  {
    "id": 65,
    "x": 155,
    "y": 293
  },
  {
    "id": 66,
    "x": 155,
    "y": 350
  },
  {
    "id": 67,
    "x": 155,
    "y": 401
  },
  {
    "id": 68,
    "x": 155,
    "y": 453
  },
  {
    "id": 69,
    "x": 155,
    "y": 504
  },
  {
    "id": 70,
    "x": 155,
    "y": 559
  },
  {
    "id": 71,
    "x": 155,
    "y": 611
  },
  {
    "id": 72,
    "x": 155,
    "y": 663
  },
  {
    "id": 73,
    "x": 155,
    "y": 720
  },
  {
    "id": 74,
    "x": 155,
    "y": 771
  },
  {
    "id": 75,
    "x": 155,
    "y": 820
  },
  {
    "id": 76,
    "x": 155,
    "y": 885
  },
  {
    "id": 77,
    "x": 230,
    "y": 974
  },
  {
    "id": 78,
    "x": 296,
    "y": 974
  },
  {
    "id": 79,
    "x": 361,
    "y": 974
  },
  {
    "id": 80,
    "x": 426,
    "y": 974
  },
  {
    "id": 81,
    "x": 483,
    "y": 974
  },
  {
    "id": 82,
    "x": 540,
    "y": 974
  },
  {
    "id": 83,
    "x": 604,
    "y": 974
  },
  {
    "id": 84,
    "x": 668,
    "y": 974
  },
  {
    "id": 85,
    "x": 729,
    "y": 974
  },
  {
    "id": 86,
    "x": 786,
    "y": 974
  },
  {
    "id": 87,
    "x": 856,
    "y": 877
  },
  {
    "id": 88,
    "x": 856,
    "y": 822
  },
  {
    "id": 89,
    "x": 856,
    "y": 772
  },
  {
    "id": 90,
    "x": 856,
    "y": 717
  },
  {
    "id": 91,
    "x": 856,
    "y": 662
  },
  {
    "id": 92,
    "x": 856,
    "y": 611
  },
  {
    "id": 93,
    "x": 856,
    "y": 558
  },
  {
    "id": 94,
    "x": 852,
    "y": 503
  },
  {
    "id": 95,
    "x": 856,
    "y": 449
  },
  {
    "id": 96,
    "x": 856,
    "y": 401
  },
  {
    "id": 97,
    "x": 852,
    "y": 348
  },
  {
    "id": 98,
    "x": 856,
    "y": 293
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_13 = {
  deviceBg: 'https://appresource.opple.com/media/business/126/20250928093417_78.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 530,
    "y": 551
  },
  {
    "id": 2,
    "x": 485,
    "y": 478
  },
  {
    "id": 3,
    "x": 522,
    "y": 436
  },
  {
    "id": 4,
    "x": 409,
    "y": 500
  },
  {
    "id": 5,
    "x": 361,
    "y": 500
  },
  {
    "id": 6,
    "x": 451,
    "y": 612
  },
  {
    "id": 7,
    "x": 573,
    "y": 581
  },
  {
    "id": 8,
    "x": 589,
    "y": 455
  },
  {
    "id": 9,
    "x": 459,
    "y": 380
  },
  {
    "id": 10,
    "x": 384,
    "y": 372
  },
  {
    "id": 11,
    "x": 328,
    "y": 511
  },
  {
    "id": 12,
    "x": 417,
    "y": 640
  },
  {
    "id": 13,
    "x": 572,
    "y": 631
  },
  {
    "id": 14,
    "x": 641,
    "y": 482
  },
  {
    "id": 15,
    "x": 546,
    "y": 347
  },
  {
    "id": 16,
    "x": 587,
    "y": 286
  },
  {
    "id": 17,
    "x": 595,
    "y": 229
  },
  {
    "id": 18,
    "x": 597,
    "y": 182
  },
  {
    "id": 19,
    "x": 573,
    "y": 130
  },
  {
    "id": 20,
    "x": 551,
    "y": 82
  },
  {
    "id": 21,
    "x": 507,
    "y": 25
  },
  {
    "id": 22,
    "x": 589,
    "y": 38
  },
  {
    "id": 23,
    "x": 660,
    "y": 59
  },
  {
    "id": 24,
    "x": 721,
    "y": 89
  },
  {
    "id": 25,
    "x": 782,
    "y": 130
  },
  {
    "id": 26,
    "x": 832,
    "y": 178
  },
  {
    "id": 27,
    "x": 880,
    "y": 239
  },
  {
    "id": 28,
    "x": 832,
    "y": 257
  },
  {
    "id": 29,
    "x": 756,
    "y": 178
  },
  {
    "id": 30,
    "x": 664,
    "y": 114
  },
  {
    "id": 31,
    "x": 704,
    "y": 193
  },
  {
    "id": 32,
    "x": 713,
    "y": 286
  },
  {
    "id": 33,
    "x": 708,
    "y": 388
  },
  {
    "id": 34,
    "x": 656,
    "y": 388
  },
  {
    "id": 35,
    "x": 774,
    "y": 300
  },
  {
    "id": 36,
    "x": 713,
    "y": 490
  },
  {
    "id": 37,
    "x": 774,
    "y": 474
  },
  {
    "id": 38,
    "x": 813,
    "y": 436
  },
  {
    "id": 39,
    "x": 850,
    "y": 392
  },
  {
    "id": 40,
    "x": 876,
    "y": 347
  },
  {
    "id": 41,
    "x": 914,
    "y": 300
  },
  {
    "id": 42,
    "x": 939,
    "y": 364
  },
  {
    "id": 43,
    "x": 955,
    "y": 436
  },
  {
    "id": 44,
    "x": 955,
    "y": 508
  },
  {
    "id": 45,
    "x": 951,
    "y": 573
  },
  {
    "id": 46,
    "x": 931,
    "y": 648
  },
  {
    "id": 47,
    "x": 908,
    "y": 709
  },
  {
    "id": 48,
    "x": 858,
    "y": 689
  },
  {
    "id": 49,
    "x": 897,
    "y": 585
  },
  {
    "id": 50,
    "x": 905,
    "y": 470
  },
  {
    "id": 51,
    "x": 864,
    "y": 541
  },
  {
    "id": 52,
    "x": 791,
    "y": 593
  },
  {
    "id": 53,
    "x": 695,
    "y": 628
  },
  {
    "id": 54,
    "x": 652,
    "y": 604
  },
  {
    "id": 55,
    "x": 801,
    "y": 651
  },
  {
    "id": 56,
    "x": 612,
    "y": 697
  },
  {
    "id": 57,
    "x": 656,
    "y": 734
  },
  {
    "id": 58,
    "x": 695,
    "y": 762
  },
  {
    "id": 59,
    "x": 749,
    "y": 766
  },
  {
    "id": 60,
    "x": 809,
    "y": 762
  },
  {
    "id": 61,
    "x": 868,
    "y": 774
  },
  {
    "id": 62,
    "x": 824,
    "y": 829
  },
  {
    "id": 63,
    "x": 778,
    "y": 876
  },
  {
    "id": 64,
    "x": 721,
    "y": 913
  },
  {
    "id": 65,
    "x": 652,
    "y": 942
  },
  {
    "id": 66,
    "x": 585,
    "y": 963
  },
  {
    "id": 67,
    "x": 511,
    "y": 976
  },
  {
    "id": 68,
    "x": 515,
    "y": 918
  },
  {
    "id": 69,
    "x": 626,
    "y": 894
  },
  {
    "id": 70,
    "x": 725,
    "y": 847
  },
  {
    "id": 71,
    "x": 641,
    "y": 847
  },
  {
    "id": 72,
    "x": 541,
    "y": 795
  },
  {
    "id": 73,
    "x": 455,
    "y": 746
  },
  {
    "id": 74,
    "x": 481,
    "y": 697
  },
  {
    "id": 75,
    "x": 507,
    "y": 847
  },
  {
    "id": 76,
    "x": 365,
    "y": 709
  },
  {
    "id": 77,
    "x": 353,
    "y": 758
  },
  {
    "id": 78,
    "x": 353,
    "y": 807
  },
  {
    "id": 79,
    "x": 373,
    "y": 855
  },
  {
    "id": 80,
    "x": 417,
    "y": 913
  },
  {
    "id": 81,
    "x": 138,
    "y": 734
  },
  {
    "id": 82,
    "x": 212,
    "y": 818
  },
  {
    "id": 83,
    "x": 301,
    "y": 880
  },
  {
    "id": 84,
    "x": 260,
    "y": 807
  },
  {
    "id": 85,
    "x": 247,
    "y": 705
  },
  {
    "id": 86,
    "x": 251,
    "y": 601
  },
  {
    "id": 87,
    "x": 311,
    "y": 601
  },
  {
    "id": 88,
    "x": 190,
    "y": 689
  },
  {
    "id": 89,
    "x": 247,
    "y": 507
  },
  {
    "id": 90,
    "x": 194,
    "y": 523
  },
  {
    "id": 91,
    "x": 150,
    "y": 555
  },
  {
    "id": 92,
    "x": 116,
    "y": 593
  },
  {
    "id": 93,
    "x": 91,
    "y": 640
  },
  {
    "id": 94,
    "x": 99,
    "y": 311
  },
  {
    "id": 95,
    "x": 64,
    "y": 422
  },
  {
    "id": 96,
    "x": 60,
    "y": 539
  },
  {
    "id": 97,
    "x": 103,
    "y": 455
  },
  {
    "id": 98,
    "x": 167,
    "y": 402
  },
  {
    "id": 99,
    "x": 272,
    "y": 343
  },
  {
    "id": 100,
    "x": 303,
    "y": 402
  },
  {
    "id": 101,
    "x": 155,
    "y": 344
  },
  {
    "id": 102,
    "x": 353,
    "y": 299
  },
  {
    "id": 103,
    "x": 314,
    "y": 259
  },
  {
    "id": 104,
    "x": 272,
    "y": 237
  },
  {
    "id": 105,
    "x": 216,
    "y": 225
  },
  {
    "id": 106,
    "x": 155,
    "y": 229
  },
  {
    "id": 107,
    "x": 441,
    "y": 81
  },
  {
    "id": 108,
    "x": 345,
    "y": 97
  },
  {
    "id": 109,
    "x": 241,
    "y": 152
  },
  {
    "id": 110,
    "x": 337,
    "y": 144
  },
  {
    "id": 111,
    "x": 427,
    "y": 205
  },
  {
    "id": 112,
    "x": 493,
    "y": 251
  },
  {
    "id": 113,
    "x": 485,
    "y": 299
  },
  {
    "id": 114,
    "x": 463,
    "y": 152
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_14 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20251015174352_21.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 536,
    "y": 525
  },
  {
    "id": 2,
    "x": 615,
    "y": 525
  },
  {
    "id": 3,
    "x": 688,
    "y": 525
  },
  {
    "id": 4,
    "x": 771,
    "y": 525
  },
  {
    "id": 5,
    "x": 849,
    "y": 525
  },
  {
    "id": 6,
    "x": 941,
    "y": 525
  },
  {
    "id": 7,
    "x": 941,
    "y": 466
  },
  {
    "id": 8,
    "x": 849,
    "y": 466
  },
  {
    "id": 9,
    "x": 771,
    "y": 466
  },
  {
    "id": 10,
    "x": 688,
    "y": 466
  },
  {
    "id": 11,
    "x": 611,
    "y": 466
  },
  {
    "id": 12,
    "x": 536,
    "y": 466
  },
  {
    "id": 13,
    "x": 461,
    "y": 466
  },
  {
    "id": 14,
    "x": 378,
    "y": 466
  },
  {
    "id": 15,
    "x": 301,
    "y": 466
  },
  {
    "id": 16,
    "x": 226,
    "y": 466
  },
  {
    "id": 17,
    "x": 149,
    "y": 466
  },
  {
    "id": 18,
    "x": 66,
    "y": 466
  },
  {
    "id": 19,
    "x": 66,
    "y": 525
  },
  {
    "id": 20,
    "x": 153,
    "y": 525
  },
  {
    "id": 21,
    "x": 226,
    "y": 525
  },
  {
    "id": 22,
    "x": 301,
    "y": 525
  },
  {
    "id": 23,
    "x": 382,
    "y": 525
  },
  {
    "id": 24,
    "x": 459,
    "y": 525
  },
  {
    "id": 25,
    "x": 887,
    "y": 496
  },
  {
    "id": 26,
    "x": 630,
    "y": 496
  },
  {
    "id": 27,
    "x": 367,
    "y": 496
  },
  {
    "id": 28,
    "x": 104,
    "y": 496
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_15 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20251015210735_10.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 586,
    "y": 689
  },
  {
    "id": 2,
    "x": 644,
    "y": 859
  },
  {
    "id": 3,
    "x": 679,
    "y": 621
  },
  {
    "id": 4,
    "x": 701,
    "y": 573
  },
  {
    "id": 5,
    "x": 701,
    "y": 473
  },
  {
    "id": 6,
    "x": 693,
    "y": 303
  },
  {
    "id": 7,
    "x": 652,
    "y": 162
  },
  {
    "id": 8,
    "x": 567,
    "y": 324
  },
  {
    "id": 9,
    "x": 437,
    "y": 324
  },
  {
    "id": 10,
    "x": 373,
    "y": 166
  },
  {
    "id": 11,
    "x": 333,
    "y": 332
  },
  {
    "id": 12,
    "x": 260,
    "y": 447
  },
  {
    "id": 13,
    "x": 217,
    "y": 573
  },
  {
    "id": 14,
    "x": 268,
    "y": 717
  },
  {
    "id": 15,
    "x": 369,
    "y": 863
  },
  {
    "id": 16,
    "x": 445,
    "y": 693
  },
  {
    "id": 17,
    "x": 664,
    "y": 934
  },
  {
    "id": 18,
    "x": 928,
    "y": 697
  },
  {
    "id": 19,
    "x": 913,
    "y": 280
  },
  {
    "id": 20,
    "x": 675,
    "y": 72
  },
  {
    "id": 21,
    "x": 348,
    "y": 64
  },
  {
    "id": 22,
    "x": 77,
    "y": 320
  },
  {
    "id": 23,
    "x": 69,
    "y": 670
  },
  {
    "id": 24,
    "x": 306,
    "y": 926
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_16 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20251021190517_75.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 964,
    "y": 520
  },
  {
    "id": 2,
    "x": 901,
    "y": 520
  },
  {
    "id": 3,
    "x": 836,
    "y": 520
  },
  {
    "id": 4,
    "x": 769,
    "y": 519
  },
  {
    "id": 5,
    "x": 699,
    "y": 520
  },
  {
    "id": 6,
    "x": 634,
    "y": 520
  },
  {
    "id": 7,
    "x": 567,
    "y": 520
  },
  {
    "id": 8,
    "x": 502,
    "y": 520
  },
  {
    "id": 9,
    "x": 437,
    "y": 520
  },
  {
    "id": 10,
    "x": 372,
    "y": 520
  },
  {
    "id": 11,
    "x": 307,
    "y": 520
  },
  {
    "id": 12,
    "x": 236,
    "y": 520
  },
  {
    "id": 13,
    "x": 171,
    "y": 520
  },
  {
    "id": 14,
    "x": 106,
    "y": 520
  },
  {
    "id": 15,
    "x": 39,
    "y": 520
  },
  {
    "id": 16,
    "x": 39,
    "y": 479
  },
  {
    "id": 17,
    "x": 106,
    "y": 479
  },
  {
    "id": 18,
    "x": 173,
    "y": 479
  },
  {
    "id": 19,
    "x": 240,
    "y": 479
  },
  {
    "id": 20,
    "x": 307,
    "y": 479
  },
  {
    "id": 21,
    "x": 372,
    "y": 479
  },
  {
    "id": 22,
    "x": 437,
    "y": 479
  },
  {
    "id": 23,
    "x": 504,
    "y": 479
  },
  {
    "id": 24,
    "x": 567,
    "y": 479
  },
  {
    "id": 25,
    "x": 634,
    "y": 479
  },
  {
    "id": 26,
    "x": 699,
    "y": 479
  },
  {
    "id": 27,
    "x": 769,
    "y": 478
  },
  {
    "id": 28,
    "x": 836,
    "y": 478
  },
  {
    "id": 29,
    "x": 901,
    "y": 478
  },
  {
    "id": 30,
    "x": 964,
    "y": 478
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_17 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20251022105446_53.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 643,
    "y": 334
  },
  {
    "id": 2,
    "x": 444,
    "y": 319
  },
  {
    "id": 3,
    "x": 440,
    "y": 438
  },
  {
    "id": 4,
    "x": 639,
    "y": 427
  },
  {
    "id": 5,
    "x": 782,
    "y": 438
  },
  {
    "id": 6,
    "x": 774,
    "y": 355
  },
  {
    "id": 7,
    "x": 675,
    "y": 199
  },
  {
    "id": 8,
    "x": 522,
    "y": 136
  },
  {
    "id": 9,
    "x": 322,
    "y": 195
  },
  {
    "id": 10,
    "x": 235,
    "y": 342
  },
  {
    "id": 11,
    "x": 207,
    "y": 431
  },
  {
    "id": 12,
    "x": 376,
    "y": 646
  },
  {
    "id": 13,
    "x": 575,
    "y": 665
  },
  {
    "id": 14,
    "x": 579,
    "y": 546
  },
  {
    "id": 15,
    "x": 380,
    "y": 558
  },
  {
    "id": 16,
    "x": 235,
    "y": 546
  },
  {
    "id": 17,
    "x": 243,
    "y": 629
  },
  {
    "id": 18,
    "x": 342,
    "y": 786
  },
  {
    "id": 19,
    "x": 523,
    "y": 850
  },
  {
    "id": 20,
    "x": 697,
    "y": 790
  },
  {
    "id": 21,
    "x": 786,
    "y": 646
  },
  {
    "id": 22,
    "x": 818,
    "y": 558
  },
  {
    "id": 23,
    "x": 931,
    "y": 359
  },
  {
    "id": 24,
    "x": 779,
    "y": 148
  },
  {
    "id": 25,
    "x": 500,
    "y": 44
  },
  {
    "id": 26,
    "x": 215,
    "y": 144
  },
  {
    "id": 27,
    "x": 69,
    "y": 346
  },
  {
    "id": 28,
    "x": 69,
    "y": 625
  },
  {
    "id": 29,
    "x": 231,
    "y": 866
  },
  {
    "id": 30,
    "x": 500,
    "y": 953
  },
  {
    "id": 31,
    "x": 766,
    "y": 862
  },
  {
    "id": 32,
    "x": 931,
    "y": 637
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_18 = {
  deviceBg: 'https://appresource.opple.com/media/business/4944/20251104142231_50.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 669,
    "y": 942
  },
  {
    "id": 2,
    "x": 525,
    "y": 972
  },
  {
    "id": 3,
    "x": 373,
    "y": 956
  },
  {
    "id": 4,
    "x": 238,
    "y": 899
  },
  {
    "id": 5,
    "x": 133,
    "y": 799
  },
  {
    "id": 6,
    "x": 59,
    "y": 678
  },
  {
    "id": 7,
    "x": 26,
    "y": 528
  },
  {
    "id": 8,
    "x": 41,
    "y": 385
  },
  {
    "id": 9,
    "x": 107,
    "y": 244
  },
  {
    "id": 10,
    "x": 199,
    "y": 137
  },
  {
    "id": 11,
    "x": 328,
    "y": 62
  },
  {
    "id": 12,
    "x": 477,
    "y": 27
  },
  {
    "id": 13,
    "x": 624,
    "y": 45
  },
  {
    "id": 14,
    "x": 755,
    "y": 100
  },
  {
    "id": 15,
    "x": 865,
    "y": 209
  },
  {
    "id": 16,
    "x": 946,
    "y": 345
  },
  {
    "id": 17,
    "x": 968,
    "y": 486
  },
  {
    "id": 18,
    "x": 960,
    "y": 624
  },
  {
    "id": 19,
    "x": 894,
    "y": 758
  },
  {
    "id": 20,
    "x": 792,
    "y": 871
  },
  {
    "id": 21,
    "x": 587,
    "y": 803
  },
  {
    "id": 22,
    "x": 435,
    "y": 811
  },
  {
    "id": 23,
    "x": 300,
    "y": 750
  },
  {
    "id": 24,
    "x": 207,
    "y": 624
  },
  {
    "id": 25,
    "x": 182,
    "y": 478
  },
  {
    "id": 26,
    "x": 230,
    "y": 329
  },
  {
    "id": 27,
    "x": 344,
    "y": 223
  },
  {
    "id": 28,
    "x": 485,
    "y": 184
  },
  {
    "id": 29,
    "x": 632,
    "y": 217
  },
  {
    "id": 30,
    "x": 755,
    "y": 311
  },
  {
    "id": 31,
    "x": 812,
    "y": 457
  },
  {
    "id": 32,
    "x": 796,
    "y": 610
  },
  {
    "id": 33,
    "x": 716,
    "y": 732
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_19 = {
  deviceBg: 'https://appresource.opple.com/media/business/4944/20251104142816_18.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 939,
    "y": 315
  },
  {
    "id": 2,
    "x": 972,
    "y": 429
  },
  {
    "id": 3,
    "x": 972,
    "y": 554
  },
  {
    "id": 4,
    "x": 947,
    "y": 665
  },
  {
    "id": 5,
    "x": 893,
    "y": 770
  },
  {
    "id": 6,
    "x": 810,
    "y": 865
  },
  {
    "id": 7,
    "x": 707,
    "y": 930
  },
  {
    "id": 8,
    "x": 594,
    "y": 969
  },
  {
    "id": 9,
    "x": 479,
    "y": 977
  },
  {
    "id": 10,
    "x": 359,
    "y": 954
  },
  {
    "id": 11,
    "x": 249,
    "y": 905
  },
  {
    "id": 12,
    "x": 156,
    "y": 829
  },
  {
    "id": 13,
    "x": 83,
    "y": 734
  },
  {
    "id": 14,
    "x": 41,
    "y": 624
  },
  {
    "id": 15,
    "x": 22,
    "y": 509
  },
  {
    "id": 16,
    "x": 33,
    "y": 391
  },
  {
    "id": 17,
    "x": 75,
    "y": 281
  },
  {
    "id": 18,
    "x": 142,
    "y": 183
  },
  {
    "id": 19,
    "x": 239,
    "y": 102
  },
  {
    "id": 20,
    "x": 341,
    "y": 49
  },
  {
    "id": 21,
    "x": 461,
    "y": 26
  },
  {
    "id": 22,
    "x": 580,
    "y": 30
  },
  {
    "id": 23,
    "x": 693,
    "y": 64
  },
  {
    "id": 24,
    "x": 797,
    "y": 125
  },
  {
    "id": 25,
    "x": 877,
    "y": 208
  },
  {
    "id": 26,
    "x": 855,
    "y": 372
  },
  {
    "id": 27,
    "x": 881,
    "y": 489
  },
  {
    "id": 28,
    "x": 869,
    "y": 604
  },
  {
    "id": 29,
    "x": 818,
    "y": 710
  },
  {
    "id": 30,
    "x": 738,
    "y": 798
  },
  {
    "id": 31,
    "x": 635,
    "y": 857
  },
  {
    "id": 32,
    "x": 518,
    "y": 883
  },
  {
    "id": 33,
    "x": 397,
    "y": 869
  },
  {
    "id": 34,
    "x": 285,
    "y": 821
  },
  {
    "id": 35,
    "x": 204,
    "y": 742
  },
  {
    "id": 36,
    "x": 142,
    "y": 639
  },
  {
    "id": 37,
    "x": 114,
    "y": 517
  },
  {
    "id": 38,
    "x": 124,
    "y": 404
  },
  {
    "id": 39,
    "x": 176,
    "y": 289
  },
  {
    "id": 40,
    "x": 257,
    "y": 200
  },
  {
    "id": 41,
    "x": 368,
    "y": 140
  },
  {
    "id": 42,
    "x": 490,
    "y": 117
  },
  {
    "id": 43,
    "x": 599,
    "y": 129
  },
  {
    "id": 44,
    "x": 711,
    "y": 179
  },
  {
    "id": 45,
    "x": 802,
    "y": 261
  },
  {
    "id": 46,
    "x": 750,
    "y": 433
  },
  {
    "id": 47,
    "x": 750,
    "y": 554
  },
  {
    "id": 48,
    "x": 701,
    "y": 665
  },
  {
    "id": 49,
    "x": 603,
    "y": 738
  },
  {
    "id": 50,
    "x": 475,
    "y": 762
  },
  {
    "id": 51,
    "x": 355,
    "y": 714
  },
  {
    "id": 52,
    "x": 277,
    "y": 628
  },
  {
    "id": 53,
    "x": 241,
    "y": 513
  },
  {
    "id": 54,
    "x": 265,
    "y": 391
  },
  {
    "id": 55,
    "x": 349,
    "y": 289
  },
  {
    "id": 56,
    "x": 460,
    "y": 242
  },
  {
    "id": 57,
    "x": 586,
    "y": 253
  },
  {
    "id": 58,
    "x": 685,
    "y": 319
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_20 = {
  deviceBg: 'https://appresource.opple.com/media/business/6724/20251114180938_60.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 710,
    "y": 394
  },
  {
    "id": 2,
    "x": 907,
    "y": 274
  },
  {
    "id": 3,
    "x": 915,
    "y": 142
  },
  {
    "id": 4,
    "x": 786,
    "y": 274
  },
  {
    "id": 5,
    "x": 497,
    "y": 124
  },
  {
    "id": 6,
    "x": 166,
    "y": 159
  },
  {
    "id": 7,
    "x": 46,
    "y": 374
  },
  {
    "id": 8,
    "x": 206,
    "y": 274
  },
  {
    "id": 9,
    "x": 206,
    "y": 426
  },
  {
    "id": 10,
    "x": 408,
    "y": 426
  },
  {
    "id": 11,
    "x": 298,
    "y": 629
  },
  {
    "id": 12,
    "x": 73,
    "y": 859
  },
  {
    "id": 13,
    "x": 86,
    "y": 741
  },
  {
    "id": 14,
    "x": 181,
    "y": 708
  },
  {
    "id": 15,
    "x": 505,
    "y": 908
  },
  {
    "id": 16,
    "x": 853,
    "y": 840
  },
  {
    "id": 17,
    "x": 957,
    "y": 625
  },
  {
    "id": 18,
    "x": 810,
    "y": 712
  },
  {
    "id": 19,
    "x": 714,
    "y": 674
  },
  {
    "id": 20,
    "x": 578,
    "y": 603
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_21 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20251216094132_51.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 451,
    "y": 307
  },
  {
    "id": 2,
    "x": 451,
    "y": 416
  },
  {
    "id": 3,
    "x": 459,
    "y": 541
  },
  {
    "id": 4,
    "x": 455,
    "y": 660
  },
  {
    "id": 5,
    "x": 455,
    "y": 769
  },
  {
    "id": 6,
    "x": 355,
    "y": 761
  },
  {
    "id": 7,
    "x": 355,
    "y": 638
  },
  {
    "id": 8,
    "x": 355,
    "y": 533
  },
  {
    "id": 9,
    "x": 355,
    "y": 416
  },
  {
    "id": 10,
    "x": 347,
    "y": 299
  },
  {
    "id": 11,
    "x": 370,
    "y": 216
  },
  {
    "id": 12,
    "x": 451,
    "y": 169
  },
  {
    "id": 13,
    "x": 443,
    "y": 44
  },
  {
    "id": 14,
    "x": 355,
    "y": 91
  },
  {
    "id": 15,
    "x": 273,
    "y": 52
  },
  {
    "id": 16,
    "x": 273,
    "y": 191
  },
  {
    "id": 17,
    "x": 196,
    "y": 71
  },
  {
    "id": 18,
    "x": 204,
    "y": 229
  },
  {
    "id": 19,
    "x": 196,
    "y": 315
  },
  {
    "id": 20,
    "x": 256,
    "y": 387
  },
  {
    "id": 21,
    "x": 200,
    "y": 468
  },
  {
    "id": 22,
    "x": 264,
    "y": 557
  },
  {
    "id": 23,
    "x": 188,
    "y": 574
  },
  {
    "id": 24,
    "x": 204,
    "y": 702
  },
  {
    "id": 25,
    "x": 192,
    "y": 769
  },
  {
    "id": 26,
    "x": 319,
    "y": 873
  },
  {
    "id": 27,
    "x": 443,
    "y": 860
  },
  {
    "id": 28,
    "x": 443,
    "y": 961
  },
  {
    "id": 29,
    "x": 319,
    "y": 957
  },
  {
    "id": 30,
    "x": 234,
    "y": 965
  },
  {
    "id": 31,
    "x": 192,
    "y": 897
  },
  {
    "id": 32,
    "x": 543,
    "y": 702
  },
  {
    "id": 33,
    "x": 543,
    "y": 593
  },
  {
    "id": 34,
    "x": 543,
    "y": 472
  },
  {
    "id": 35,
    "x": 543,
    "y": 370
  },
  {
    "id": 36,
    "x": 547,
    "y": 249
  },
  {
    "id": 37,
    "x": 645,
    "y": 245
  },
  {
    "id": 38,
    "x": 645,
    "y": 366
  },
  {
    "id": 39,
    "x": 644,
    "y": 476
  },
  {
    "id": 40,
    "x": 653,
    "y": 589
  },
  {
    "id": 41,
    "x": 645,
    "y": 710
  },
  {
    "id": 42,
    "x": 620,
    "y": 789
  },
  {
    "id": 43,
    "x": 535,
    "y": 839
  },
  {
    "id": 44,
    "x": 551,
    "y": 957
  },
  {
    "id": 45,
    "x": 637,
    "y": 901
  },
  {
    "id": 46,
    "x": 723,
    "y": 961
  },
  {
    "id": 47,
    "x": 727,
    "y": 822
  },
  {
    "id": 48,
    "x": 800,
    "y": 931
  },
  {
    "id": 49,
    "x": 800,
    "y": 777
  },
  {
    "id": 50,
    "x": 761,
    "y": 706
  },
  {
    "id": 51,
    "x": 735,
    "y": 617
  },
  {
    "id": 52,
    "x": 797,
    "y": 541
  },
  {
    "id": 53,
    "x": 735,
    "y": 442
  },
  {
    "id": 54,
    "x": 743,
    "y": 358
  },
  {
    "id": 55,
    "x": 797,
    "y": 299
  },
  {
    "id": 56,
    "x": 780,
    "y": 241
  },
  {
    "id": 57,
    "x": 667,
    "y": 130
  },
  {
    "id": 58,
    "x": 551,
    "y": 142
  },
  {
    "id": 59,
    "x": 551,
    "y": 44
  },
  {
    "id": 60,
    "x": 675,
    "y": 44
  },
  {
    "id": 61,
    "x": 762,
    "y": 36
  },
  {
    "id": 62,
    "x": 814,
    "y": 122
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_22 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20260107100653_18.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 691,
    "y": 566
  },
  {
    "id": 2,
    "x": 567,
    "y": 532
  },
  {
    "id": 3,
    "x": 578,
    "y": 263
  },
  {
    "id": 4,
    "x": 441,
    "y": 287
  },
  {
    "id": 5,
    "x": 445,
    "y": 685
  },
  {
    "id": 6,
    "x": 563,
    "y": 729
  },
  {
    "id": 7,
    "x": 669,
    "y": 914
  },
  {
    "id": 8,
    "x": 496,
    "y": 936
  },
  {
    "id": 9,
    "x": 324,
    "y": 914
  },
  {
    "id": 10,
    "x": 342,
    "y": 699
  },
  {
    "id": 11,
    "x": 334,
    "y": 489
  },
  {
    "id": 12,
    "x": 350,
    "y": 258
  },
  {
    "id": 13,
    "x": 358,
    "y": 66
  },
  {
    "id": 14,
    "x": 545,
    "y": 57
  },
  {
    "id": 15,
    "x": 687,
    "y": 223
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_23 = {
  deviceBg: 'https://appresource.opple.com/media/business/4850/20260107111654_74.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 642,
    "y": 317
  },
  {
    "id": 2,
    "x": 400,
    "y": 321
  },
  {
    "id": 3,
    "x": 392,
    "y": 457
  },
  {
    "id": 4,
    "x": 607,
    "y": 430
  },
  {
    "id": 5,
    "x": 816,
    "y": 446
  },
  {
    "id": 6,
    "x": 798,
    "y": 323
  },
  {
    "id": 7,
    "x": 688,
    "y": 209
  },
  {
    "id": 8,
    "x": 466,
    "y": 125
  },
  {
    "id": 9,
    "x": 315,
    "y": 217
  },
  {
    "id": 10,
    "x": 189,
    "y": 323
  },
  {
    "id": 11,
    "x": 155,
    "y": 446
  },
  {
    "id": 12,
    "x": 354,
    "y": 661
  },
  {
    "id": 13,
    "x": 619,
    "y": 682
  },
  {
    "id": 14,
    "x": 611,
    "y": 549
  },
  {
    "id": 15,
    "x": 389,
    "y": 545
  },
  {
    "id": 16,
    "x": 177,
    "y": 553
  },
  {
    "id": 17,
    "x": 193,
    "y": 674
  },
  {
    "id": 18,
    "x": 303,
    "y": 793
  },
  {
    "id": 19,
    "x": 524,
    "y": 864
  },
  {
    "id": 20,
    "x": 680,
    "y": 793
  },
  {
    "id": 21,
    "x": 794,
    "y": 663
  },
  {
    "id": 22,
    "x": 836,
    "y": 549
  },
  {
    "id": 23,
    "x": 944,
    "y": 457
  },
  {
    "id": 24,
    "x": 918,
    "y": 359
  },
  {
    "id": 25,
    "x": 880,
    "y": 270
  },
  {
    "id": 26,
    "x": 816,
    "y": 177
  },
  {
    "id": 27,
    "x": 720,
    "y": 111
  },
  {
    "id": 28,
    "x": 611,
    "y": 70
  },
  {
    "id": 29,
    "x": 496,
    "y": 54
  },
  {
    "id": 30,
    "x": 393,
    "y": 66
  },
  {
    "id": 31,
    "x": 303,
    "y": 103
  },
  {
    "id": 32,
    "x": 215,
    "y": 145
  },
  {
    "id": 33,
    "x": 155,
    "y": 213
  },
  {
    "id": 34,
    "x": 99,
    "y": 293
  },
  {
    "id": 35,
    "x": 71,
    "y": 389
  },
  {
    "id": 36,
    "x": 43,
    "y": 500
  },
  {
    "id": 37,
    "x": 65,
    "y": 608
  },
  {
    "id": 38,
    "x": 99,
    "y": 707
  },
  {
    "id": 39,
    "x": 155,
    "y": 785
  },
  {
    "id": 40,
    "x": 237,
    "y": 856
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_24 = {
  deviceBg: 'https://appresource.opple.com/media/business/3484/20260116180323_79.png',
  deviceText: '3060',
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
  {
    "id": 1,
    "x": 611,
    "y": 216
  },
  {
    "id": 2,
    "x": 524,
    "y": 232
  },
  {
    "id": 3,
    "x": 557,
    "y": 537
  },
  {
    "id": 4,
    "x": 769,
    "y": 174
  },
  {
    "id": 5,
    "x": 684,
    "y": 47
  },
  {
    "id": 6,
    "x": 876,
    "y": 130
  },
  {
    "id": 7,
    "x": 859,
    "y": 316
  },
  {
    "id": 8,
    "x": 739,
    "y": 415
  },
  {
    "id": 9,
    "x": 735,
    "y": 537
  },
  {
    "id": 10,
    "x": 747,
    "y": 720
  },
  {
    "id": 11,
    "x": 891,
    "y": 646
  },
  {
    "id": 12,
    "x": 668,
    "y": 768
  },
  {
    "id": 13,
    "x": 715,
    "y": 900
  },
  {
    "id": 14,
    "x": 549,
    "y": 808
  },
  {
    "id": 15,
    "x": 387,
    "y": 741
  },
  {
    "id": 16,
    "x": 474,
    "y": 584
  },
  {
    "id": 17,
    "x": 446,
    "y": 411
  },
  {
    "id": 18,
    "x": 237,
    "y": 827
  },
  {
    "id": 19,
    "x": 312,
    "y": 891
  },
  {
    "id": 20,
    "x": 132,
    "y": 823
  },
  {
    "id": 21,
    "x": 146,
    "y": 628
  },
  {
    "id": 22,
    "x": 270,
    "y": 529
  },
  {
    "id": 23,
    "x": 278,
    "y": 403
  },
  {
    "id": 24,
    "x": 264,
    "y": 236
  },
  {
    "id": 25,
    "x": 113,
    "y": 300
  },
  {
    "id": 26,
    "x": 349,
    "y": 172
  },
  {
    "id": 27,
    "x": 286,
    "y": 39
  },
  {
    "id": 28,
    "x": 446,
    "y": 131
  }
].map(item => ({
    id: item.id,
    x: Math.floor(item.x * 0.7) -10,
    y: Math.floor(item.y *  0.7) - 10,
    shadow: item.shadow
  }))
}

export const TEMPLATE_29 = {
  deviceBg: 'https://appresource.opple.com/media/business/361240/20260805185639_98.png',
  deviceText: 'Mesh3060',
  // 底板图 1000x1000，点位同图坐标系；画布宽 700 → *0.7；再减半个灯点尺寸做居中
  scale: 1,
  isGroup: false,
  shape: 2, // 1 圆形 2 矩形
  posList: [
    { id: 1, x: 620, y: 331 },
    { id: 2, x: 533, y: 183 },
    { id: 3, x: 456, y: 327 },
    { id: 4, x: 386, y: 183 },
    { id: 5, x: 309, y: 135 },
    { id: 6, x: 309, y: 691 },
    { id: 7, x: 390, y: 810 },
    { id: 8, x: 474, y: 644 },
    { id: 9, x: 561, y: 810 },
    { id: 10, x: 612, y: 882 },
    { id: 11, x: 497, y: 983, shadow: true },
    { id: 12, x: 601, y: 983, shadow: true },
    { id: 13, x: 706, y: 901, shadow: true },
    { id: 14, x: 706, y: 716, shadow: true },
    { id: 15, x: 706, y: 541, shadow: true },
    { id: 16, x: 706, y: 377, shadow: true },
    { id: 17, x: 706, y: 221, shadow: true },
    { id: 18, x: 706, y: 83, shadow: true },
    { id: 19, x: 599, y: 21, shadow: true },
    { id: 20, x: 486, y: 21, shadow: true },
  ].map(item => ({
    ...item,
    x: Math.floor(item.x * 0.7 - 7),
    y: Math.floor(item.y * 0.7 - 7),
  }))
}